import { denormalize } from "normalizr";

import { fundingRequest } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.fundingRequests.ids;

    const denormalized = denormalize(
      { items },
      { items: [fundingRequest] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
